import React, { useState } from "react"
import propTypes from "prop-types"

import IconSvg from "@atoms/IconSvg/IconSvg"
import minusIcon from "@images/svg/minus.svg"
import plusIcon from "@images/svg/plus.svg"
import CheckboxGroup from "@molecules/CheckboxGroup/CheckboxGroup"
import FilterTextField from "@molecules/FilterTextField/FilterTextField"

const MobileCheckboxFilter = ({
  index,
  isOpen,
  heading,
  openAccordionIndex,
  setOpenAccordionIndex,
  list,
  onCheck,
  initialState,
  groupName,
  checkboxRefs,
  textSearchSettings,
}) => {
  const [filteredItems, setFilteredItems] = useState(list)

  return (
    <li className="border-b border-gray-50 border-solid" key={heading}>
      <button
        className="flex justify-between items-center w-full py-2.5"
        onClick={() =>
          setOpenAccordionIndex(openAccordionIndex === index ? null : index)
        }
      >
        <strong className="block leading-2 text-sm font-inter font-bold">
          {heading}
        </strong>
        <IconSvg Icon={isOpen ? minusIcon : plusIcon} widthClass="w-2.5" />
      </button>
      <div className={!isOpen ? "hidden" : "mt-2 mb-4"}>
        {textSearchSettings?.apply && (
          <div className={"pb-4"}>
            <FilterTextField
              listToFilter={filteredItems}
              initialList={list}
              updateList={setFilteredItems}
              placeholder={textSearchSettings.placeholder}
              useShadow={false}
            />
          </div>
        )}
        <CheckboxGroup
          list={filteredItems}
          onCheck={onCheck}
          initialState={initialState}
          groupName={groupName}
          ref={(el) =>
            checkboxRefs.current[index] || checkboxRefs.current.push(el)
          }
        />
      </div>
    </li>
  )
}

MobileCheckboxFilter.propTypes = {
  index: propTypes.number.isRequired,
  isOpen: propTypes.bool.isRequired,
  heading: propTypes.string.isRequired,
  openAccordionIndex: propTypes.number,
  setOpenAccordionIndex: propTypes.func.isRequired,
  list: propTypes.arrayOf(
    propTypes.shape({
      name: propTypes.string.isRequired,
      label: propTypes.string.isRequired,
    })
  ).isRequired,
  onCheck: propTypes.func.isRequired,
  initialState: propTypes.objectOf(propTypes.bool.isRequired),
  groupName: propTypes.string.isRequired,
  checkboxRefs: propTypes.object.isRequired,
  textSearchSettings: propTypes.shape({
    apply: propTypes.bool,
    placeholder: propTypes.string,
  }),
}

export default MobileCheckboxFilter
